import styled from '@emotion/styled';

const Section = styled.section`
	padding: 1.5rem;
	background: #111827;
	color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 1rem;
`;

const Logo = styled.img`
	max-height: 2rem;
	object-fit: contain;
`;

export default function PoweredBlockAlpha({ tenantLogo }: { tenantLogo: string }) {
	return (
		<Section>
			<span>Presented by</span>
			<Logo src={tenantLogo} alt="Tenant logo" />
		</Section>
	);
}
